import React, { useEffect } from 'react';
import { logout } from '../../services/Login';

export default React.forwardRef((props, ref) => {
  useEffect(() => {
    logout().then(()=> {
      window.localStorage.clear();
      window.location.href = '/';
    })
  }, []);
  return null;
}); 
